/**
 * EventBus — Pub/sub bridge between React state and Phaser scenes.
 *
 * Both React components and Phaser scenes import this singleton to
 * communicate without direct coupling.
 */

const listeners = {};

const EventBus = {
  on(event, callback) {
    if (!listeners[event]) listeners[event] = [];
    listeners[event].push(callback);
  },

  off(event, callback) {
    if (!listeners[event]) return;
    listeners[event] = listeners[event].filter((cb) => cb !== callback);
  },

  emit(event, data) {
    if (!listeners[event]) return;
    listeners[event].forEach((cb) => cb(data));
  },

  removeAll(event) {
    if (event) {
      delete listeners[event];
    } else {
      Object.keys(listeners).forEach((key) => delete listeners[key]);
    }
  },
};

export default EventBus;
